import React from 'react'
import dynamic from 'next/dynamic'
import { usePartnerPromo, usePartner } from '@pcln/whitelabel-components'
import { useFeature } from '@pcln/feature-components'
import { useContentful } from '@pcln/contentful-components'

const SearchFormAd = dynamic(() => import('../../SearchFormAd'))
const PartnerPromo = dynamic(() => import('./PartnerPromo'))
const SearchPromoBanner = () => {
  const contentfulEnabled = useFeature('whiteLabel.contentfulEnabled')
  const searchForm: any = useContentful('searchForm')
  const searchPromoBannerValidPromos = usePartner(
    'config.landingPage.customMerchandising.searchPromoBannerActivePromo.validPromos'
  )
  const partnerConfig = usePartnerPromo(
    `config.landingPage.customMerchandising.searchPromoBannerActivePromo`,
    `config.landingPage.customMerchandising.searchPromoBanner`,
    searchPromoBannerValidPromos
  )
  if (contentfulEnabled && searchForm?.adUnit !== undefined) {
    return <SearchFormAd {...searchForm.adUnit} />
  }
  return partnerConfig ? <PartnerPromo partnerConfig={partnerConfig} /> : null
}
export default SearchPromoBanner
